"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BudgetAllocationResponseSchema = void 0;
const core_1 = require("../../core");
const ruby_1 = require("../../ruby");
exports.BudgetAllocationResponseSchema = (0, core_1.StrictObject)({
    ...core_1.ModelMetaFields,
    teamId: core_1.IdSchema,
    campaignId: core_1.IdSchema,
    details: ruby_1.AllocationDetailsSchema,
    allocatedAt: core_1.TimestampSchema,
    totalAmount: core_1.MoneySchema,
    dailyBudget: core_1.MoneySchema,
});
